import React, { FC, useCallback } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { RadioGroup } from '@cld/radio';
import { GroupLayout, InlineFieldLayout, Label } from '@cld/form';
import { Section } from '../../common/Section';
import { messages } from '../../../../i18n';
import { FilterType, SearchOptions } from '../../../../types';
import { useOptions } from '../../../../selectors';
import { updateOptions } from '../../../../actions';
import { OpenOptionsFolder } from './OpenOptionsFolder';
import { OpenOptionsSearch } from './OpenOptionsSearch';

export const OpenOptions: FC = () => {
  const { formatMessage } = useIntl();
  const {
    filterSelection,
    folderName = '',
    filterByExpression = '',
    filterByAsset,
    isSearchFilterByAsset = false,
    isSearchFilterByCustomExpression = false,
  } = useOptions();
  const dispatch = useDispatch();

  const handleFilterSelection = useCallback(
    (value: FilterType) => {
      dispatch(updateOptions({ filterSelection: value }));
    },
    [dispatch]
  );

  const handleFolderApply = useCallback(
    (folder: string) => {
      dispatch(updateOptions({ folderName: folder }));
    },
    [dispatch]
  );

  const handleSearchApply = useCallback(
    (search: SearchOptions) => {
      return dispatch(updateOptions({ ...search }));
    },
    [dispatch]
  );

  return (
    <Section title={formatMessage(messages['demo.section.filter'])}>
      <GroupLayout>
        <RadioGroup name="radio" value={filterSelection} onChange={handleFilterSelection}>
          <InlineFieldLayout label={<Label htmlFor="filter-folder"><FormattedMessage {...messages['demo.section.filter.folder.label']} /></Label>}>
            <RadioGroup.Radio
              id="filter-folder"
              value={FilterType.Folder}
              inputProps={{
                'data-test': 'folder-radio-button'
              }}
            />
          </InlineFieldLayout>
          {filterSelection === FilterType.Folder && <OpenOptionsFolder folder={folderName} onApply={handleFolderApply} />}
          <InlineFieldLayout label={<Label htmlFor="filter-search"><FormattedMessage {...messages['demo.section.filter.search']} /></Label>}>
            <RadioGroup.Radio
              id="filter-search"
              value={FilterType.Search}
              inputProps={{
                'data-test': 'search-radio-button'
              }}
            />
          </InlineFieldLayout>
          {filterSelection === FilterType.Search && (
            <OpenOptionsSearch
              isSearchFilterByAsset={isSearchFilterByAsset}
              isSearchFilterByCustomExpression={isSearchFilterByCustomExpression}
              filterByAsset={filterByAsset}
              filterByExpression={filterByExpression}
              onApply={handleSearchApply}
            />
          )}
        </RadioGroup>
      </GroupLayout>
    </Section>
  );
};
